import { useEffect } from "react"
import { _single, _WorkActivityGroup } from "../../../core/services/dataBean/EntityCatalog"
import useDataBean from "../../../core/services/dataBean/useDataBean"
import useModal, { MODAL_LG, MODAL_md, MODAL_SM } from "../../theme/Component/hooks/useModal"
import { toast } from "react-toastify"
import { ListMenu } from "../../theme/Component/ListMenu"
import { BasicPage } from "../../theme/Component/BasicPage"
import { BasicTable } from "../../theme/Component/BasicTable"
import { Modal } from "../../theme/Component/Modal"
import { ModalConfirm } from "../../theme/Component/ModalConfirm"
import { WorkActivityGroupUser } from "./WorkActivityGroupUser/WorkActivityGroupUser"

export const WorkActivityGroup = () => {

    const { instance, bean, setBean, lista, setLista, addRequiredFields, isRequired, isMissing, validateForm } = useDataBean(_WorkActivityGroup)

    const modal = useModal("", MODAL_md);
    const modalTeam = useModal("Grupo de Trabajo", MODAL_LG);
    const modalC = useModal("Eliminar tipo de Actividad", MODAL_SM);


    useEffect(() => {
        addRequiredFields(["GroupName"])
        getLista();
    }, [])

    const getLista = () => {
        const props = {
            State: 1
        }

        instance.getWorkActivityGroupCatalogPorPropiedades(props, null).then(
            (resp: any) => {
                setLista(resp);
            }
        ).catch(err => {
            toast.error("Error al cargar los grupos");
        });
    };

    const create = () => {
        setBean({
            State: 1,
        });
        modal.open("Agregar grupos de Tareas")
    }

    const deleteItem = () => {
        const x = { ...bean, State: 2 };
        editaItem(x);
    };

    const editaItem = (obj: any) => {
        if (!validateForm()) {
            toast.error("Faltan Campos Obligatorios por diligenciar");
            return;
        }
        instance.updateWorkActivityGroup(obj).then(
            (resp: any) => {
                getLista();
                modal.close();
                modalC.close()
            }
        ).catch(err => {
            toast.error(err);
        })
    }

    const head = [
        { title: 'ID', property: 'IDWorkActivityGroup', visible: true },
        { title: 'Nombre', property: 'GroupName', visible: true },
        { title: 'Descripción', property: 'Description', visible: true },
    ];


    const iconButtonsItem = [
        { nombre: 'Agregar', visible: _single.canCreate(), icono: 'ri-file-add-line', evento: create }
    ]

    const listaBotones = () => {
        const botones = [
            { titulo: 'Editar', icono: 'ri-edit-2-line', visible: _single.canEdit(), evento: () => { modal.open(`Editar grupo ${bean.GroupName}`) } },
            { titulo: 'Usuarios', icono: 'ri-team-line', visible: _single.canEdit(), evento: () => { modalTeam.open(); } },
            { titulo: 'Eliminar', icono: 'ri-delete-bin-line', visible: _single.canDelete(), evento: () => { modalC.open() } },
        ]
        return (
            <ListMenu listaBotones={botones} />
        )
    }

    return (
        <BasicPage titulo="Grupos de Resolucion de Tareas">
            <div className="row">
                <div className="col-md-12">
                    <BasicTable body={lista} head={head} rowSet={setBean} listButtons={listaBotones()} iconButtons={iconButtonsItem} />

                    <Modal modal={modal.modal} updateModal={modal.setModal} eventModal={() => { editaItem(bean) }}>
                        <div className="row">
                            <div className="col-md-12">
                                <label className={`${isMissing('GroupName') ? 'has-error' : ''}`} >Nombre del Grupo {isRequired('GroupName') ? <span className="text-danger">*</span> : ''}</label>
                                <input type="text" className="form-control" value={bean.GroupName} onChange={(e) => { setBean({ ...bean, GroupName: e.target.value }) }} />
                            </div>

                            <div className="col-md-12">
                                <label>Descripción {isRequired('Description') ? <span className="text-danger">*</span> : ''}</label>
                                <textarea className="form-control" value={bean.Description} onChange={(e) => { setBean({ ...bean, Description: e.target.value }) }} />
                            </div>
                        </div>
                    </Modal>

                    <ModalConfirm modal={modalC.modal} updateModal={modalC.setModal} eventModal={deleteItem}>
                        <strong>Eliminar item {bean.GroupName}</strong>
                    </ModalConfirm>

                    <Modal modal={modalTeam.modal} updateModal={modalTeam.setModal}  >
                        <WorkActivityGroupUser WorkActivityGroup={bean} />
                    </Modal>

                </div>
            </div>
        </BasicPage>
    )
}